export interface IFetch {
  fetching?: boolean;
  fetched?: boolean;
  success?: boolean;
  successMessage?: string | null;
  errorMessage?: string | null;
}

export const constructNewFetch = ({
  fetching = false,
  fetched = false,
  success = false,
  successMessage = null,
  errorMessage = null,
}: IFetch = {}) => ({
  fetching,
  fetched,
  success,
  errorMessage,
  successMessage,
});
